import { IApplicationState } from '../../types/redux';

export const selectIsAvailableFiltersLoading = (state: IApplicationState) =>
  state.marketTrand.isAvailableFiltersLoading;

export const selectIsMarketTrandLoading = (state: IApplicationState) => state.marketTrand.isMarketTrandLoading;

export const selectIsSupplyDemandLoading = (state: IApplicationState) => state.marketTrand.isSupplyDemandLoading;
